import { LogOut, History, Sparkles, Clock } from "lucide-react";
import { Button } from "./ui/button";

function fmtTime(d) {
  return d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}

function fmtDate(d) {
  return d.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });
}

export default function TopBar({ settings, nowTick, onLogout, onOpenHistory }) {
  const now = new Date(nowTick);
  const isHappy = settings?.is_happy_hour_now;
  const club = settings?.club_name || "Cue Lounge";

  return (
    <header
      className="sticky top-0 z-30 w-full px-4 sm:px-6 lg:px-8 pt-4"
      data-testid="top-bar"
    >
      <div className="w-full flex items-center justify-between bg-black/50 backdrop-blur-xl border border-white/10 px-5 py-3 rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.45)]">
        <div className="flex items-center gap-4 min-w-0">
          <div className="w-9 h-9 rounded-full bg-[#d4af37] grid place-items-center text-black font-black shadow-lg shadow-amber-500/20">
            8
          </div>
          <div className="min-w-0">
            <div
              data-testid="top-bar-club-name"
              className="text-lg font-black tracking-tight text-white truncate"
            >
              {club}
            </div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-amber-400/80">
              Snooker · Live Console
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {isHappy && (
            <div
              data-testid="happy-hour-badge"
              className="happy-pulse hidden md:inline-flex items-center gap-2 bg-amber-500/15 text-amber-300 border border-amber-500/40 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider"
            >
              <Sparkles className="w-3.5 h-3.5" />
              Happy Hour · {settings?.currency_symbol || "₹"}
              {settings?.rate_happy_hour}/hr
            </div>
          )}

          <div
            className="hidden sm:flex items-center gap-2 text-gray-300 bg-white/5 border border-white/10 px-3 py-1.5 rounded-full"
            data-testid="top-bar-clock"
          >
            <Clock className="w-4 h-4 text-amber-400" />
            <span className="font-mono text-sm tracking-wider">
              {fmtTime(now)}
            </span>
            <span className="text-xs text-gray-500">{fmtDate(now)}</span>
          </div>

          <Button
            variant="ghost"
            onClick={onOpenHistory}
            data-testid="open-history-btn"
            className="text-gray-300 hover:text-white hover:bg-white/5"
          >
            <History className="w-4 h-4 mr-2" />
            History
          </Button>

          <Button
            variant="ghost"
            onClick={onLogout}
            data-testid="logout-btn"
            className="text-gray-400 hover:text-red-400 hover:bg-red-500/10"
          >
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
